interface Base64ImageProps {
  base64String: string;
  altText?: string;
  sx?: any;
}

const QRCodeDisplay = ({ altText, base64String, sx }: Base64ImageProps) => {
  const imageSource = base64String.startsWith("data:")
    ? base64String
    : `data:image/jpeg;base64,${base64String}`;

  return (
    <img
      src={imageSource}
      alt={altText}
      style={{
        ...sx,
        borderRadius: "15px",
        border: "2px solid #eee",
      }}
    />
  );
};

export default QRCodeDisplay;
